export async function getSeriesList(childId) {
  const { api } = await import('./client');
  return api.get(`/library/series?childId=${childId}`);
}

export async function getSeriesDetail(seriesId, childId) {
  const { api } = await import('./client');
  return api.get(`/library/series/${seriesId}?childId=${childId}`);
}

export async function startPrewrittenStory(templateId, childId) {
  const { api } = await import('./client');
  return api.post(`/library/start/${templateId}`, { childId });
}

export async function getEvalStory(childId, band) {
  const { api } = await import('./client');
  const params = new URLSearchParams({ childId, band });
  try {
    return await api.get(`/library/eval?${params.toString()}`);
  } catch (err) {
    // api wrapper throws Error('Request failed: <status>') on non-2xx.
    // Re-throw with a parseable `.status` so callers (PlacementBandPage)
    // can branch on 404 without string matching.
    const match = err?.message?.match(/Request failed: (\d+)/);
    if (match) {
      const e = new Error(err.message);
      e.status = Number(match[1]);
      throw e;
    }
    throw err;
  }
}
